"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUnits = void 0;
const generateUnits = (definition) => {
    const result = {};
    const baseValue = definition.unit?.base?.px;
    // If base value hasn't changed, we don't need to regenerate tokens
    if (!baseValue)
        return;
    for (let i = 1; i <= 10; i += 1) {
        const generatedName = `x${i}`;
        result[generatedName] = { px: baseValue * i };
    }
    return result;
};
exports.generateUnits = generateUnits;
